import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failures = ['Los "Mega-Prompts" de internet son demasiado complejos y confunden la jerarquía de atención de la IA.', 'Copiar y pegar listas genéricas no te enseña a razonar, solo te hace dependiente de plantillas que caducan.', 'Tratar a la IA como un oráculo mágico en lugar de un motor de predicción estadística garantiza resultados vagos.', 'No poner restricciones negativas permite que el bot rellene tu trabajo con "alucinaciones" y frases acartonadas.'];
export function FailedSolutions() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-16">
            ¿Por Qué Lo Que Has Intentado{' '}
            <span className="text-red-400" data-id="element-17">No Funciona?</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-18">
          {failures.map((failure, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="glass-card p-6 rounded-2xl border-red-500/10 hover:border-red-500/30 transition-all group" data-id="element-19">
              <div className="flex items-start" data-id="element-20">
                <XCircleIcon className="w-8 h-8 text-red-500/70 group-hover:text-red-400 flex-shrink-0 mt-1 transition-colors" data-id="element-21" />
                <p className="ml-4 text-gray-300 text-lg leading-relaxed" data-id="element-22">
                  {failure}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}